export type Client = {
  id: string;
  tenant_id: string;
  full_name: string;
  email: string;
  phone: string;
  address: string;
  notes: string;
  status: string;
  created_at: string;
  updated_at: string;
};

export type ClientContract = {
  id: string;
  contract_number: string;
  title: string;
  event_date: string;
  total_amount: number;
  deposit_amount: number;
  balance_amount: number;
  status: string;
  payment_status: string;
  created_at: string;
};

export type ClientJob = {
  id: string;
  title: string;
  job_type: string;
  status: string;
  shoot_date: string | null;
  location: string | null;
  created_at: string;
};

export type ClientPayment = {
  id: string;
  amount: number;
  status: string;
  method: string | null;
  notes: string | null;
  reference: string | null;
  payment_date: string | null;
  contract_id: string | null;
  contract_number: string | null;
  created_at: string;
};

export type PortalToken = {
  id: string;
  token: string;
  short_code: string;
  status: string;        // 'active' | 'revoked' | 'inactive'
  created_at: string;
  updated_at: string | null;
  expires_at: string | null;
};

export type Tab = "overview" | "portal" | "contracts" | "jobs" | "payments" | "messages" | "addons";

export const TABS: { id: Tab; label: string; icon: string }[] = [
  { id: "overview",   label: "Overview",      icon: "ri-user-line" },
  { id: "portal",     label: "Portal Access", icon: "ri-shield-keyhole-line" },
  { id: "contracts",  label: "Contracts",     icon: "ri-file-text-line" },
  { id: "jobs",       label: "Jobs",          icon: "ri-camera-3-line" },
  { id: "payments",   label: "Payments",      icon: "ri-money-dollar-circle-line" },
  { id: "messages",   label: "Messages",      icon: "ri-message-3-line" },
  { id: "addons",     label: "Add-ons",       icon: "ri-vip-crown-line" },
];